<script setup lang="ts">
import type { PropType } from 'vue';

interface PegInformation {
  startPegNumber?: number | string
  endPegNumber?: number | string
}

const props = defineProps({
  pegInformation: {
    type: Object as PropType<PegInformation>,
    required: true,
    default: () => ({})
  }
});
</script>

<template>
  <v-card class="mx-auto my-5" max-width="550" elevation="2">
    <v-card-title class="text-subtitle-1 font-weight-bold bg-grey-lighten-4">
      Work Area Overview
    </v-card-title>
    
    <v-divider></v-divider>

    <v-card-text class="pt-4 d-flex flex-column">
      <div class="text-body-2 text-medium-emphasis mb-4">
        Showing the lowest and highest peg numbers registered in this session.
      </div>
      <div class="d-flex justify-space-between align-center mb-4">
        <span class="text-body-1 text-medium-emphasis">Lowest registered pegnumber:</span>
        <span class="text-h6 font-weight-bold text-blue-grey-darken-3 font-monospace">{{ props.pegInformation.startPegNumber ?? '-' }}</span>
      </div>
      
      <div class="d-flex justify-space-between align-center">
        <span class="text-body-1 text-medium-emphasis">Highest registered pegnumber:</span>
        <span class="text-h6 font-weight-bold text-blue-grey-darken-3 font-monospace">{{ props.pegInformation.endPegNumber ?? '-' }}</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.font-monospace {
  font-family: 'Courier New', Courier, monospace !important;
}
</style>